export default __webpack_public_path__ + "static/media/basement_W112-DF-13-EI90.beb3c892.jpg";